import { yup } from '@guiker/shared-framework'

import { MultipostListingInquiryParser } from '../../../../entity/multipost-listing-inquiry'

export const multipostInquiryPerformanceStatsPayloadSchema = yup.object<{
  listingIds: string[]
  parser: MultipostListingInquiryParser
  days?: number
}>({
  listingIds: yup.array().of(yup.string()).min(1).required(),
  parser: yup.string().oneOf(Object.values(MultipostListingInquiryParser)).required(),
  days: yup.number().optional().default(7),
})
